import classNames from 'classnames'
import React from 'react'
import { useState } from 'react'
import { useForm } from 'react-hook-form'
import http, { baseURLPublic } from '../../../config/BaseUrl'

const EmailModal = ({sendEmail}) => {

    const [loading, setLoading] =useState(false)
    const [closeModal, setCloseModal] =useState("")
    const [isSuccess, setIsSuccess] = useState(false)
    const {register, handleSubmit, formState:{errors}, reset } = useForm({mode:"all", reValidateMode:"onChange"})
    const handelEmailSend = async (data) => {
        const shareEmail = {
            event_id:sendEmail.event_id,
            media_id:sendEmail.media_id,
            sharing_platform:"email",
            email:data.send_email,
            email_share:"email"
        }

        setLoading(true)
        await baseURLPublic.post("share-gallery-count-email-sms", shareEmail).then((res) => {
            if(res){
                setLoading(false)
                setCloseModal("modal")
                reset()
                setIsSuccess(true)

                setTimeout(()=>{
                    setIsSuccess(false)
                }, 2000)
                return "success"
            }
        }).catch((err) => {
            setLoading(false)
        })
    }
    return (
            <div className="modal fade" id="socialShareEmail" tabIndex={-1} role="dialog" aria-hidden="true">
                <div className="modal-dialog modal-dialog-centered">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h5 className="modal-title">Send Email</h5>
                            <button type="button" className="close" data-dismiss="modal" aria-label="Close">	
                                <span aria-hidden="true">×</span>
                            </button>
                        </div>
                        <form onSubmit={handleSubmit(handelEmailSend)}>
                            <div className="modal-body my-5">
                                {!loading ? 
                                (
                                    
                                    isSuccess ?
                                        <h3 className="text-center text-primary">Successfully shared</h3>
                                    :
                                    <>
                                        <input 
                                            type="email" 
                                            className={classNames("form-control", {"is-invalid":errors.send_email})}
                                            placeholder="Enter an email address." 
                                            {...register("send_email", {
                                                required:"This field is required"
                                            })}
                                        />
                                        <small className="text-danger">{errors.send_email && errors.send_email.message}</small>
                                    </>
                                )
                                :<h3 className="text-center text-primary">Email Sharing...</h3>}

                                
             
                            </div>
                            <div className="modal-footer">
                                <button type="button" className="btn btn-secondary" data-dismiss="modal" >Close</button>
                                <button type="submit" className="btn btn-primary" >Send</button>
                            </div>
                        </form>
                    </div>
                </div>
            </div>



    )
}

export default EmailModal
